import { createSelector } from 'reselect';
import { transformPartnerChallenges } from './transformer';

export const campaignsState = (state) => state.campaigns.campaigns || [];

export const campaignsLoadingState = (state) =>
    state.campaigns.campaignsLoading || false;

export const getCampaigns = createSelector(campaignsState, (campaigns) =>
    transformPartnerChallenges(campaigns),
);

export const getCampaignsLoading = createSelector(
    campaignsLoadingState,
    (loading) => loading,
);
